import React from 'react';
import './FactionGoblinsDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {MINUS_SIGN} from "../../../../constants/text";
import {
  GOBLINS_ABILITY_RADIUS,
  GOBLINS_ABILITY_SUCCESS_THRESHOLD,
  GOBLINS_FORTRESS_DAMAGE_PENALTY,
  GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY,
  GOBLINS_TRAP_REMOVAL_REWARD,
  GOBLINS_TRAP_SETUP_COST
} from "../../../../configs/factions/goblins";

const FactionGoblinsDescription = () => {
  const unitFriend = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const unitSize = <img
    className={'policy-description-icon'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  const sizeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={unitSize}
    icon={`${GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY}+`}
  />;

  const ability = <img
    className={'faction-description-icon faction-description-icon-margin-right'}
    src={'/img/icons/ability.png'}
    alt={'Способность'}
    title={'Способность'}
  />;

  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;

  const rangeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={distance}
    icon={GOBLINS_ABILITY_RADIUS}
  />;

  // Без правого отступа - сразу после значения дальности идёт запятая
  // (в "Саботаже"), и лишний отступ выглядел как пробел перед ней
  const rangeValueAndIconNoRightMargin = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={distance}
    icon={GOBLINS_ABILITY_RADIUS}
  />;

  const setupCost = <CoinsStat
    text={GOBLINS_TRAP_SETUP_COST}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  const removalReward = <CoinsStat
    text={`+${GOBLINS_TRAP_REMOVAL_REWARD}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const unitEnemy = <img
    className={'policy-description-icon-unit'}
    src={'/img/icons/unit d6 enemy.png'}
    alt={'Отряд противника'}
    title={'Отряд противника'}
  />;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;

  const trap = <img
    className={'policy-description-icon'}
    src={'/img/icons/trap.png'}
    alt={'Ловушка'}
    title={'Ловушка'}
  />;

  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-min'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;

  const buildingDamage = <img
    className={'policy-description-icon'}
    src={'/img/icons/building_damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;

  const fortress = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-min'}
    src={'/img/hexes/special buildings/fortress button.6fed26ae.png'}
    alt={'Крепость'}
    title={'Крепость'}
  />;

  const dice = <img
    className={'policy-description-icon'}
    src={'/img/icons/dice.png'}
    alt={'Бросок кости'}
    title={'Бросок кости'}
  />;

  const diceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={'d6'}
    icon={dice}
  />;

  const fortressDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={`d6${MINUS_SIGN}${GOBLINS_FORTRESS_DAMAGE_PENALTY}`}
    icon={buildingDamage}
  />;

  return (
    <>
      <div className="policy-description_line faction-goblins-description_intro-line">
        {unitFriend}{sizeValueAndIcon} имеют способности:
      </div>

      <div className="policy-description_line">
        {ability} <span className={'text-goblins'}>Ловушка</span> {rangeValueAndIcon} {setupCost},{' '}{diceValueAndIcon} успех {GOBLINS_ABILITY_SUCCESS_THRESHOLD}+:
      </div>
      <div className="faction-goblins-description_wrapped-line">
        Ставит {trap} в ячейку, не смежную {unitEnemy}. Пройдя смежно {trap}, {unitEnemy} получает 1-3 {damage}
      </div>

      <div className="policy-description_line">
        {ability} <span className={'text-goblins'}>Снятие ловушки</span> {rangeValueAndIcon}:{' '}{removalReward}
      </div>

      <div className="policy-description_line">
        {ability} <span className={'text-goblins'}>Саботаж</span> {rangeValueAndIconNoRightMargin},{' '}{diceValueAndIcon} успех {GOBLINS_ABILITY_SUCCESS_THRESHOLD}+:
      </div>
      <div className="faction-goblins-description_wrapped-line">
        {city} получает {buildingDamage}, {fortress} получает {fortressDamageValueAndIcon}
      </div>
    </>
  );
};

export default FactionGoblinsDescription;
